import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  questionAnswerCategoryId: string;
  body: {
    id: string;
    displayOrder: number;
  }[];
};

const request = ({ questionAnswerCategoryId, body }: RequestDataType) => {
  return new ApiClient()
    .put<ResponseMessageType>(
      `/api/managers/question_answer_categories/${questionAnswerCategoryId}/display_order`,
      {
        questionAnswerCategory: { questionAnswers: body },
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersQuestionAnswerCategoriesDisplayOrdersUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
